import { KrCard } from '@/common/card/KrCard';
import { useDashboardContext } from '@/common/dashboard/DashboardContext';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { McdFinTrendChart } from './McdFinTrendChart';

export const DispTrendsCard = () => {
  const [isChart, setIsChart] = useNavStateSync('dispTrendIsChart', true);
  const { formValues } = useDashboardContext();
  if (!formValues) {
    return null;
  }
  const dispTrendButtons = (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={isChart}
      sx={{ width: 'fit-content' }}
      onChange={(event, value) => {
        setIsChart(value);
      }}
    >
      <ToggleButton value={true} aria-label="bold">
        Chart
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Table
      </ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <KrCard title="Quarter Over Quarter Dispute Trends" buttons={dispTrendButtons}>
      <McdFinTrendChart formValues={formValues} isPaid={false} isChart={isChart} />
    </KrCard>
  );
};
